import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useLangRoute from "@/hooks/useLangRoute";
import Logo from "@/components/Logo";

export default function Footer({ onOpenCookies }) {
  const { t } = useTranslation();
  const { path } = useLangRoute();
  const year = new Date().getFullYear();

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    else window.location.href = `${path("/")}#${id}`;
  };

  return (
    <footer className="bg-[#0F1B2D] text-[#EDE7DA]">
      <div className="mx-auto max-w-6xl px-5 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2">
            <Logo withText={false} />
            <span className="font-semibold tracking-tight text-[#EDE7DA]">
              mirexi<span className="text-[#E9B949]">luna</span>
            </span>
          </div>
          <p className="mt-3 text-[13px] leading-relaxed text-[#EDE7DA]/70">{t("footer.tagline")}</p>
        </div>

        <div>
          <h4 className="text-[12px] font-semibold uppercase tracking-wider text-[#E9B949]">{t("footer.company")}</h4>
          <ul className="mt-4 space-y-2 text-[14px]">
            <li><a href={`${path("/")}#how`} onClick={scrollTo("how")} className="hover:text-white" data-testid="footer-how">{t("nav.how")}</a></li>
            <li><a href={`${path("/")}#projects`} onClick={scrollTo("projects")} className="hover:text-white" data-testid="footer-projects">{t("nav.projects")}</a></li>
            <li><a href={`${path("/")}#about`} onClick={scrollTo("about")} className="hover:text-white" data-testid="footer-about">{t("nav.about")}</a></li>
            <li><a href={`${path("/")}#contact`} onClick={scrollTo("contact")} className="hover:text-white" data-testid="footer-contact">{t("nav.contact")}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[12px] font-semibold uppercase tracking-wider text-[#E9B949]">{t("footer.legal")}</h4>
          <ul className="mt-4 space-y-2 text-[14px]">
            <li><Link to={path("privacy")} className="hover:text-white" data-testid="footer-privacy">{t("nav.privacy")}</Link></li>
            <li><Link to={path("cookies")} className="hover:text-white" data-testid="footer-cookies">{t("nav.cookies")}</Link></li>
            <li><Link to={path("terms")} className="hover:text-white" data-testid="footer-terms">{t("nav.terms")}</Link></li>
            <li>
              <button type="button" onClick={onOpenCookies} className="hover:text-white text-left" data-testid="footer-cookie-prefs">
                {t("cookie.manage")}
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-[12px] font-semibold uppercase tracking-wider text-[#E9B949]">{t("footer.legalTitle")}</h4>
          <ul className="mt-4 space-y-1.5 text-[12.5px] leading-relaxed text-[#EDE7DA]/80">
            <li>{t("footer.legalName")}</li>
            <li>{t("footer.legalReg")}</li>
            <li>{t("footer.legalTax")}</li>
            <li>{t("footer.legalLicense")}</li>
            <li>{t("footer.legalJur")}</li>
            <li>{t("footer.legalYear")}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-6xl px-5 py-5 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="text-[12px] text-[#EDE7DA]/60">© {year} Mirexiluna Capital Urbano S.A.S. — {t("footer.rights")}</p>
          <p className="text-[12px] text-[#EDE7DA]/60">
            <a href="mailto:hola@mirexiluna.com" className="hover:text-white" data-testid="footer-email">hola@mirexiluna.com</a>
          </p>
        </div>
        <div className="mx-auto max-w-6xl px-5 pb-8">
          <p className="text-[11.5px] leading-relaxed text-[#EDE7DA]/50">{t("footer.disclaimer")}</p>
        </div>
      </div>
    </footer>
  );
}
